export const Burger = ((add_overlay = true, active_body_class = "nav-is-open", active_menu_class = "is-open") => {
	let $body = document.body;

	const openMenu = (trigger) => {
		trigger.setAttribute("data-state", "opened");
		trigger.setAttribute("aria-expanded", "true");

		document.querySelector(`#${trigger.getAttribute("aria-controls")}`).classList.add(active_menu_class);
		$body.classList.add(active_body_class);
	};

	const closeMenu = (trigger) => {
		trigger.setAttribute("data-state", "closed");
		trigger.setAttribute("aria-expanded", "false");

		document.querySelector(`#${trigger.getAttribute("aria-controls")}`).classList.remove(active_menu_class);
		$body.classList.remove(active_body_class);
	};

	const makeOverlay = () => {
		if (!add_overlay) return;
		// Create overlay
		let overlay = document.createElement("div");
		overlay.classList.add("overlay");
		overlay.setAttribute("aria-hidden", true);
		$body.insertAdjacentElement("beforeend", overlay);
	};

	const bindEvents = (trigger) => {
		// if no overlay, close when click outside nav
		if (!add_overlay) {
			document.addEventListener(
				"mouseup",
				(e) => {
					if (!e.target.closest(`#${trigger.getAttribute("aria-controls")}`)) {
						closeMenu(trigger);
					}
				},
				false
			);
		} else {
			document.querySelector(".overlay").addEventListener(
				"click",
				() => {
					closeMenu(trigger);
				},
				false
			);
		}
	};

	const init = () => {
		let $burger_triggers = document.querySelectorAll("[data-burger]");

		if (add_overlay) {
			makeOverlay();
		}

		if (!$burger_triggers.length) {
			console.warn("Please make sure you have at least one element with [data-burger] on your DOM");
		} else {
			$burger_triggers.forEach((trigger) => {
				trigger.addEventListener("click", (e) => {
					let currentState = e.currentTarget.getAttribute("data-state");
					!currentState || currentState === "closed" ? openMenu(e.currentTarget) : closeMenu(e.currentTarget);
				});
				bindEvents(trigger);
			});
		}
	};

	return {
		init: init,
	};
})();
